import { observable, action, runInAction } from "mobx";
import * as API from "../../../../api/m/teamsShare";
import { getLabel } from "@weapp/utils";
import { Dialog } from "@weapp/ui";
import { mainHost } from "../../../../utils";

const { message } = Dialog;
const host = mainHost();

class MTeamsShareListStore {
  @observable spining: boolean = false;//加载中
  @observable startDate: string = '';
  @observable endDate: string = '';
  @observable keywords: string = '';
  @observable range: string = 'company';
  @observable workType: string = 'share';
  @observable shareScope: any = 'all';
  @observable publishtype: any = 'share';
  @observable rangeUserId: any = 0;
  @observable teamShareList: any[] = [];
  @observable rangeData: any = [
    { id: 'company', content: getLabel('62230', '全团队') },
    { id: 'watched', content: getLabel('80996', '关注同事') },
    { id: 'directSubordinates', content: getLabel('80998', '直接下属') },
    { id: 'subordinates', content: getLabel('80997', '所有下属') },
    { id: 'superiors', content: getLabel('62231', '我上级的') },
    { id: 'department', content: getLabel('62233', '本部门') },
    { id: 'otherDepartment', content: getLabel('62234', '其他部门') },
  ];

  @action
  init = () => {
    this.getData();
    this.loadMyfollow();
  };

  @action
  onPageChange = (value: number) => {
    this.getData(value);
  }

  @action
  getData = (pageNo?: number | null) => {
    this.spining = true;
    const params: any = {
      pageSize: 25,
      pageNo: pageNo || 1,
      workDynaFilter: {
        range: this.range,
        workType: this.workType,
        keywords: this.keywords,
        startDate: this.startDate,
        endDate: this.endDate,
      },
    }
    if (this.rangeUserId && this.rangeUserId != 0 && this.rangeUserId != '') {
      params.workDynaFilter['creator'] = this.rangeUserId;
    }
    API.getData(params).then((result: any) => {
      runInAction(() => {
        if (result) {
          this.spining = false;

          if (pageNo) {
            this.teamShareList = this.teamShareList.concat([...(result.workDynaPage.result || [])]);
          } else {
            this.teamShareList = [...(result.workDynaPage.result || [])];
          }
          this.handLoadAtParams();
          this.handleFileData();
        }
      });
    });
  };

  @action
  handleFileData = () => {
    if (this.teamShareList && this.teamShareList.length > 0) {
      this.teamShareList.forEach(item => {
        let praised = false;
        let praiseUser = '';
        if (item && item.imageFiles && item.imageFiles.length > 0) {
          item.imageFiles.forEach((item: any) => {
            item.src = `/papi/file/preview?fileId=${item.bigUrl}&type=imgs`;
          })
        }
        if (item && item.attachments && item.attachments.length > 0) {
          item.attachments.forEach((item: any) => {
            item.fileid = item.id;
            item.isImg = item.image;
            // item.options = fileOptions;
          })
        }
        if (item && item.praisePage && item.praisePage.length > 0) {
          item.praisePage.forEach((data: any, index: number) => {
            if (data.entityUser) {
              if (data.entityUser.id === window.TEAMS.currentUser?.id) {
                praised = true;
              }
              if (index === item.praisePage.length - 1) {
                praiseUser += data.entityUser.name
              } else {
                praiseUser += data.entityUser.name + ',';
              }
            }
          })
        }
        item.praised = praised;
        item.praiseUser = praiseUser;
      })
    }
  }

  @action
  handLoadAtParams = () => {
    if (this.teamShareList && this.teamShareList.length > 0) {
      let userDataE10: any = [];
      this.teamShareList.forEach(comment => {
        comment.contentE10 = comment.content;
        comment.contentE10Edit = comment.content;
        let userData = comment.userData;
        if (userData) {
          userData = JSON.parse(userData);
          if (userData && userData.length > 0) {
            userData.forEach((ud: any) => {
              ud.atType = 'user';
              userDataE10.push(ud);
            })
            comment.userDataE10 = userDataE10;
            userData.reverse().forEach((ud: any) => {
              let index = ud.userIdIndex - 1;
              let idstr = ':@' + ud.userId + ';'
              let name = '@' + ud.userName;
              if (comment.contentE10) comment.contentE10 = comment.contentE10.slice(0, index) + idstr + comment.contentE10.slice(index)
              if (comment.contentE10Edit) comment.contentE10Edit = comment.contentE10Edit.slice(0, index) + name + comment.contentE10Edit.slice(index)
            })

          }
        }
      })
    }
  }

  @action
  loadMyfollow = () => {
    const params = { pageNo: 1, pageSize: 10, approvedOnly: true };
    API.loadMyfollow(params)
      .then((result: any) => {
        runInAction(() => {
          if (result) {
            if (result.data && result.data.user && result.data.user.superior) {
            } else {
              this.rangeData = this.rangeData.filter((item: any) => item.id !== 'superiors');
            }
            if (result.data && result.data.page && result.data.page.totalCount) {
            } else {
              this.rangeData = this.rangeData.filter((item: any) => item.id !== 'watched');
            }
          }
          const params = { pageNo: 1, pageSize: 10 };
          API.loadSubordinate(params)
            .then((result: any) => {
              runInAction(() => {
                if (result) {
                  if (result && result.page && result.page.totalCount) {
                  } else {
                    this.rangeData = this.rangeData.filter((item: any) => item.id !== 'directSubordinates');
                    this.rangeData = this.rangeData.filter((item: any) => item.id !== 'subordinates');
                  }
                }
              });
            })
            .catch((error) => {
              console.log(error);
            });
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  @action
  publish = (value: any, attachments: any, data: any) => {
    if (!value || value.trim() === '') {
      message({
        type: 'info',
        content: getLabel('183337', '请填写内容后再提交'),
      });
      return;
    }
    if (value.length > 1000) {
      message({
        type: 'info',
        content: getLabel('183338', '内容过长，单次输入不超过1000字'),
      });
      return;
    }
    const params: any = {
      blog: {
        content: data.content,
        imAtContent: data.imAtContent,
        shareScope: this.shareScope,
        userIdIndex: [],
        userIds: [],
      },
      publishtype: this.publishtype
    };
    if (attachments && attachments != '') {
      params.blog['attachmentIds'] = attachments;
    }
    this.handSaveAtParams(params, data);
    API.publish(params)
      .then((result: any) => {
        runInAction(() => {
          if (result) {
            message({
              type: 'success',
              content: getLabel('173490', '发布成功!'),
            });
            this.getData();
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  @action
  handSaveAtParams = (params: any, data: any) => {
    if (data && data.atLinkList && data.atLinkList.length > 0) {
      let userId: any = [];
      let userIdIndex: any = [];
      let context = data.imAtContent;
      data.atLinkList.forEach((link: any) => {
        let id = link.userId;
        let s = ':@' + id + ';';
        userId.push(id);
        let index = context.indexOf(s);
        userIdIndex.push(id + '-' + (index + 1));
        context = context.replace(s, '');
      })
      params.blog.userIds = userId;
      params.blog.userIdIndex = userIdIndex;
    }
  }

  @action
  praise = (id: any) => {
    const params = {
      praise: {
        entityId: id,
        userId: window.TEAMS.currentUser.id,
        module: 'share',
      }
    };
    API.praise(params)
      .then((result: any) => {
        runInAction(() => {
          if (result) {
            this.getData();
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  @action
  updateType = (value: any) => {
    this.workType = value;
    this.getData();
  }

  @action
  updateRange = (value: any) => {
    this.range = value;
    this.getData();
  }

  @action
  updateDate = (value: any) => {
    this.startDate = value;
    this.getData();
  }

  @action
  updateShareScope = (value: any) => {
    this.shareScope = value;
  }

  @action
  updateKeywords = (value: any) => {
    this.teamShareList = [];
    this.keywords = value;
    this.getData();
  }

  @action
  updateUserId = (value: any) => {
    this.rangeUserId = value;
  }

}

const instance = new MTeamsShareListStore();

export default instance;
